import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedFlight } from '@stencil/flights-seo-reducers/src/SRP/redux/actions';
import {
  displayOnwardFlightsSelector,
  isFlightSelectedSelector,
  airportsSelector,
  travelTypeSelector
} from '@stencil/flights-seo-reducers/src/SRP/redux/selectors';
import MMTAd from '@stencil/commonstories/src/components/common/mmt-ads/mmt-ads';
import TryAgain from '@stencil/commonstories/src/components/Seo/try-again/try-again';
import useListLazyLoading from '@stencil/use-list-lazy-loading';
import SeoSrpCard from '../srp-card/srp-card';
import insertAnElementIntoArrayAtSpecificIndex from '@stencil/flights-utils/src/insert-an-element-into-array-at-specific-index';
import { setConfig } from '@stencil/commonstories/src/components/AdTech/adWrapper';

const GIAdsInitialConfig = {
  ORG: 'GI',
  mode: 'PROD',
  API_CALL: 'SINGLE',
  AUTH_COOKIE_KEY: 'OAUTH-GOIBIBO',
  AUTHORIZATION: 'DFjgkXbgFGBvebc',
  AUTHORITY: 'adorch.goibibo.com',
  userCallbackForView: (id, adResponse) => {},
  userClickHandlerForClick: (id, adResponse) => {},
  onError: (error, id) => {},
  onAdsRendered: obj => {}
};

setConfig(GIAdsInitialConfig);

const SeoSrpList = props => {
  const { isRoute = false } = props;
  const dispatch = useDispatch();
  const displayOnwardFlights = useSelector(displayOnwardFlightsSelector);
  const travelType = useSelector(travelTypeSelector);

  const handleFlightSelection = flight => {
    dispatch(updateSelectedFlight(flight));
  };

  const isFlightSelected = useSelector(isFlightSelectedSelector);
  const airports = useSelector(airportsSelector);

  if (!displayOnwardFlights || displayOnwardFlights.length < 1) {
    return <TryAgain isDweb={true} />;
  }

  const { loaderRef, currentDisplayList, canAddMore } = useListLazyLoading(displayOnwardFlights);

  const flightList = currentDisplayList
    ? currentDisplayList.map(displayFlights => (
        <SeoSrpCard
          key={displayFlights.id}
          flightItem={displayFlights}
          isFlightSelected={isFlightSelected}
          handleFlightSelection={handleFlightSelection}
          airports={airports}
        />
      ))
    : [];

  return (
    <div>
      {flightList.slice(0, 3)}
      {isRoute && flightList.length > 0 ? (
        <MMTAd
          cid={
            travelType === 'international'
              ? 'RkxJR0hUX0lOVCNTRU8jQkVUV0VFTiBDQVJEUyAx'
              : 'RkxJR0hUI1NFTyNCRVRXRUVOIENBUkRTIDE='
          }
          styles={{ margin: '10px auto', width: '728px' }}
        />
      ) : null}
      {flightList.slice(3)}
      {canAddMore ? <div ref={loaderRef}></div> : null}
    </div>
  );
};

export default SeoSrpList;
